/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import {
  Image, StyledText,
} from '..'
import PreviewPlayer from '../PreviewPlayer'
import { API_IMAGE_OBJECT } from '../../utils/types'
import { colors } from '../../styles'
import styles from './styles'
import HeroCTA from '../HeroCTA'
import HeroLiveTicker from '../HeroLiveTicker'
import { UPDATE_PREVIEW_PLAYER_PROPS } from '../../constants'

const HeroCard = ({
  el,
  mobileHeroImage,
  webHeroImage,
  large,
  link,
  linkGuid,
  title,
  overlay,
  hasHoverOverlay,
  newWindow,
  addClasses,
  noScale,
  sponsorship,
  forceAds,
  vipExclusive,
  vipProhibited,
  svodExclusive,
  svodProhibited,
  specialEvent,
  subGenre,
  recoID,
  rank,
  ctaButtonLink,
  ctaButtonText,
  ctaButtonType,
  ctaText,
  live,
  index,
  poster,
  page,
  showCTA,
  progmImages,
  name,
  longDescription,
  progmButton,
  progmButtonLink,
  availableEpisodes,
  programmeHead,
  audioDescribed,
  visuallySigned,
  isSubtitle,
  programmeDetails,
  isGuidance,
  prgmGenre,
  programmeTab,
  liveTab,
  hasInformation,
  playing,
  informationText,
  hasCompetitionText,
  competitionText,
  isVisible,
  autoplayShortform,
  inViewScroll,
  userPaused,
  firstRotation,
  isStvLiveProg,
  liveProgramme,
}) => {
  const Element = el
  const classes = ['CardRefresh', (large ? 'large' : ''), (programmeHead ? 'programHead' : ''), ((programmeTab || liveTab) ? 'tabCard' : ''), (noScale ? 'no-scale' : ''), (poster ? 'poster' : ''), (specialEvent ? 'specialEvent' : ''), (page === 'categories' ? 'categories' : ''), ...addClasses]
    .filter(Boolean)
    .join(' ')

  const position = live ? index + 1 : rank; // eslint-disable-line
  const [background, setBackground] = useState(webHeroImage)
  const [showAnimation, setShowAnimation] = useState(showCTA)
  const [isMobile, setIsMobile] = useState(false)
  const [loadPlayer, setLoadPlayer] = useState(true)
  const isLive = !!((liveProgramme?.guid === linkGuid || liveProgramme?.title === title))
  const psEnabled = useSelector(state => state?.featureFlags?.psEnabled)

  useEffect(() => {
    if (window.innerWidth >= 768) {
      setShowAnimation(showCTA)
      setBackground(webHeroImage)
      setIsMobile(false)
    } else {
      setShowAnimation(true)
      setBackground(mobileHeroImage)
      setIsMobile(true)
    }
  })
  useEffect(() => {
    // pause player when scrolled from view
    if (playing && !userPaused) {
      window.postMessage({
        type: UPDATE_PREVIEW_PLAYER_PROPS,
        newData: { paused: !inViewScroll },
      }, '*')
    }
    // unmount player if scrolled from view before playback starts
    if (!playing && firstRotation) {
      setLoadPlayer(!!inViewScroll)
    }
  }, [inViewScroll])

  return (
    <Element
      className={classes}
      title={title}
    >
      <figure
        style={hasHoverOverlay && (page === 'home' || page === 'categories') ? { zIndex: 3 } : {}}
        className={`${!programmeHead ? 'home' : ''}`}
      >
        {((programmeHead && isStvLiveProg) || (!programmeHead && ctaButtonType === 'watchLive') || (!programmeHead && (liveProgramme?.guid === linkGuid || liveProgramme?.title === title))) && !psEnabled && (
          <HeroLiveTicker
            programmeHead={programmeHead}
          />
        )}
        <>
          {!isMobile && isVisible && loadPlayer && firstRotation && (
            <div className={`preview-player ${programmeHead ? 'programme-head' : ''}`}>
              <PreviewPlayer
                userPaused={userPaused}
                playing={playing}
                autoplayShortform={autoplayShortform}
                title={title}
                genre={prgmGenre}
                subGenre={subGenre}
                inViewScroll={inViewScroll}
                programmeHead={programmeHead}
              />
            </div>
          )}
          <div className={`preview-image ${playing ? 'hidden' : ''}`}>
            <Image
              image={programmeHead ? progmImages : background}
              sponsorship={sponsorship}
              sizes="100vw"
              priority={specialEvent}
            />
          </div>
        </>
        {overlay && (
          <figcaption>
            <StyledText
              el="p"
              className="cardSubtitle"
              style={{ color: colors.primaryText }}
            >
              {overlay}
            </StyledText>
          </figcaption>
        )}
        {specialEvent && (
          <div>
            <span className={!programmeHead ? 'Home' : ''}> {null} </span>
            { showAnimation && !programmeHead
              && (
                <div className={['hero-cta-wrapper', showAnimation ? 'animationend' : ''].join(' ')}>
                  <HeroCTA
                    title={title}
                    text={ctaText}
                    index={index}
                    buttonText={ctaButtonText}
                    buttonType={ctaButtonType}
                    buttonLink={link}
                    forceAds={forceAds}
                    svodExclusive={svodExclusive}
                    svodProhibited={svodProhibited}
                    vipExclusive={vipExclusive}
                    vipProhibited={vipProhibited}
                    isHomepage
                    genre={prgmGenre}
                    isGuidance={isGuidance}
                    isSubtitle={isSubtitle}
                    availableEpisodes={availableEpisodes}
                    audioDescribed={audioDescribed}
                    visuallySigned={visuallySigned}
                    liveProgramme={isLive}
                  />
                </div>
              )}
            {programmeHead && (
              <div className="hero-cta-wrapper-program">
                <HeroCTA
                  title={name}
                  genre={prgmGenre}
                  availableEpisodes={availableEpisodes}
                  text={longDescription}
                  buttonText={isStvLiveProg ? 'Watch live' : progmButton}
                  buttonType={isStvLiveProg ? 'watchLive' : 'watchNow'}
                  buttonLink={isStvLiveProg ? '/live/stv' : progmButtonLink}
                  isGuidance={isGuidance}
                  audioDescribed={audioDescribed}
                  visuallySigned={visuallySigned}
                  isSubtitle={isSubtitle}
                  forceAds={forceAds}
                  svodExclusive={svodExclusive}
                  svodProhibited={svodProhibited}
                  vipExclusive={vipExclusive}
                  vipProhibited={vipProhibited}
                  programmeDetails={programmeDetails}
                  programmeHead={programmeHead}
                  hasInformation={hasInformation}
                  hasCompetitionText={hasCompetitionText}
                  competitionText={competitionText}
                  isStvLiveProg={isStvLiveProg}
                  informationText={informationText}
                  liveProgramme={isLive}
                />
              </div>
            )}
          </div>
        )}
      </figure>
      <style jsx>{styles}</style>
    </Element>
  )
}
HeroCard.propTypes = {
  el: PropTypes.string,
  progmImages: API_IMAGE_OBJECT,
  webHeroImage: API_IMAGE_OBJECT,
  mobileHeroImage: API_IMAGE_OBJECT,
  large: PropTypes.bool,
  link: PropTypes.string,
  linkGuid: PropTypes.string,
  title: PropTypes.string,
  overlay: PropTypes.string,
  hasHoverOverlay: PropTypes.bool,
  newWindow: PropTypes.bool,
  addClasses: PropTypes.arrayOf(PropTypes.string),
  noScale: PropTypes.bool,
  programmeDetails: PropTypes.shape({
    title: PropTypes.string,
    images: API_IMAGE_OBJECT,
    guid: PropTypes.string,
  }),
  sponsorship: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    image: PropTypes.shape({
      id: PropTypes.number,
      _filepath: PropTypes.string,
    }),
  }),
  forceAds: PropTypes.bool,
  svodExclusive: PropTypes.bool,
  svodProhibited: PropTypes.bool,
  vipExclusive: PropTypes.bool,
  vipProhibited: PropTypes.bool,
  specialEvent: PropTypes.bool,
  recoID: PropTypes.string,
  rank: PropTypes.number,
  ctaButtonLink: PropTypes.string,
  ctaButtonText: PropTypes.string,
  ctaButtonType: PropTypes.string,
  ctaText: PropTypes.string,
  live: PropTypes.bool,
  index: PropTypes.number,
  poster: PropTypes.bool,
  page: PropTypes.string,
  showCTA: PropTypes.bool,
  name: PropTypes.string,
  longDescription: PropTypes.string,
  progmButton: PropTypes.string,
  availableEpisodes: PropTypes.string,
  programmeHead: PropTypes.bool,
  audioDescribed: PropTypes.bool,
  visuallySigned: PropTypes.bool,
  isSubtitle: PropTypes.bool,
  isGuidance: PropTypes.bool,
  prgmGenre: PropTypes.string,
  subGenre: PropTypes.string,
  progmButtonLink: PropTypes.string,
  programmeTab: PropTypes.bool,
  liveTab: PropTypes.bool,
  hasInformation: PropTypes.bool,
  playing: PropTypes.bool,
  competitionText: PropTypes.string,
  informationText: PropTypes.string,
  hasCompetitionText: PropTypes.bool,
  isVisible: PropTypes.bool,
  autoplayShortform: PropTypes.shape({
    videoId: PropTypes.number,
    drmEnabled: PropTypes.bool,
  }),
  inViewScroll: PropTypes.bool,
  userPaused: PropTypes.bool,
  firstRotation: PropTypes.bool,
  isStvLiveProg: PropTypes.bool,
  liveProgramme: PropTypes.shape({
    title: PropTypes.string,
    guid: PropTypes.string,
  }),
}
HeroCard.defaultProps = {
  el: 'li',
  progmImages: {},
  programmeDetails: {},
  webHeroImage: {},
  mobileHeroImage: {},
  large: false,
  title: '',
  overlay: '',
  hasHoverOverlay: false,
  newWindow: false,
  addClasses: [],
  noScale: false,
  link: null,
  linkGuid: null,
  sponsorship: null,
  forceAds: false,
  svodExclusive: false,
  svodProhibited: false,
  vipExclusive: false,
  vipProhibited: false,
  specialEvent: false,
  recoID: null,
  rank: null,
  ctaButtonLink: null,
  ctaButtonText: null,
  ctaButtonType: null,
  ctaText: null,
  live: false,
  index: null,
  poster: false,
  page: null,
  showCTA: false,
  name: '',
  longDescription: '',
  progmButton: '',
  availableEpisodes: '',
  programmeHead: false,
  audioDescribed: false,
  visuallySigned: false,
  isSubtitle: false,
  isGuidance: false,
  prgmGenre: '',
  subGenre: '',
  progmButtonLink: '',
  programmeTab: false,
  liveTab: false,
  hasInformation: false,
  playing: false,
  competitionText: '',
  informationText: '',
  hasCompetitionText: false,
  isVisible: true,
  autoplayShortform: {},
  inViewScroll: true,
  userPaused: false,
  firstRotation: true,
  isStvLiveProg: false,
  liveProgramme: {},
}
export default HeroCard
